import { render, staticRenderFns } from "./ExportRequestsTableMobile.vue?vue&type=template&id=1f868cf5&scoped=true"
import script from "./ExportRequestsTableMobile.vue?vue&type=script&lang=js"
export * from "./ExportRequestsTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f868cf5",
  null
  
)

export default component.exports